<div class="payment-methods-settings-container">
    <div class="cssload-container" *ngIf="isLoading">
        <div class="cssload-speeding-wheel"></div>
      </div>
  <div class="modal-header">
    <h2>{{ 'subscription.paymentMethods' | translate }}</h2>
    <button class="close-button" (click)="onClose()" aria-label="Close">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <div *ngIf="loading" class="loading">
      {{ 'common.loading' | translate }}
    </div>

    <div *ngIf="error" class="error-message">
      {{ error }}
    </div>

    <div class="payment-methods-table" *ngIf="!loading && !error ">
      <table *ngIf="paymentMethods.length > 0">
        <thead>
          <tr>
            <th>{{ 'subscription.cardOwner' | translate }}</th>
            <th>{{ 'subscription.brandName' | translate }}</th>
            <th>{{ 'subscription.last4Digits' | translate }}</th>
            <th>{{ 'subscription.expirationDate' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="payment-method-table-row"
            [class.selected]="selectedPaymentMethodId === (paymentMethod._id || paymentMethod.id)"
            [class.default]="paymentMethod.isDefault"
            [class.expired]="paymentMethod.expired"
            (click)="!paymentMethod.isDefault ? onPaymentMethodSelect(paymentMethod) : null"
            *ngFor="let paymentMethod of paymentMethods"
          > 
            <td>
              <div class="payment-method-owner">
                {{ paymentMethod.cardOwner }}
                <span *ngIf="paymentMethod.isDefault" class="default-badge">
                  <svg *ngIf="!paymentMethod.expired" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <circle cx="10" cy="10.5" r="10" fill="#7ab383"></circle>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.54883 10.3059L8.43376 13.9991L14.6756 5.95459" fill="#7ab383"></path>
                    <path d="M4.54883 10.3059L8.43376 13.9991L14.6756 5.95459" stroke="#ffffff"></path></svg>
                  <svg *ngIf="paymentMethod.expired" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <circle cx="10" cy="10.5" r="10" fill="#868687"></circle>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.54883 10.3059L8.43376 13.9991L14.6756 5.95459" fill="#868687"></path>
                    <path d="M4.54883 10.3059L8.43376 13.9991L14.6756 5.95459" stroke="#ffffff"></path></svg>
                </span>
            </div>
            </td>
            <td>
              <div class="payment-method-info">
                <span class="payment-method-type">{{ paymentMethod.brand | translate }}{{" "}}({{ paymentMethod.funding | translate }})</span>
              </div>
            </td>
            <td>
              {{  paymentMethod.last4 }}
            </td>
            <td *ngIf="!paymentMethod.expired">
              {{ paymentMethod.expirationDate }}
            </td>
            <td *ngIf="paymentMethod.expired">
              <span class="expiration-date-label">
                {{ 'subscription.expired' | translate }}
              </span>
            </td>
          </tr> 
        </tbody>
      </table>
      <div *ngIf="paymentMethods.length === 0" class="no-payment-methods">
        {{ 'subscription.noPaymentMethods' | translate }}
        <button
          class="add-payment-method-button "
          (click)="onAddPaymentMethod()"
        >
          + {{ 'subscription.addPaymentMethod' | translate }}
        </button>
      </div>
      <div class="payment-method-actions" *ngIf="paymentMethods.length > 0">
        <button
          class="add-payment-method-button"
          (click)="onAddPaymentMethod()"
        >
          + {{ 'subscription.addPaymentMethod' | translate }}
        </button>
        <button
          *ngIf="selectedPaymentMethodId"
          class="set-default-button"
          (click)="onSetDefaultPaymentMethod()"
          [disabled]="settingDefault"
        >
          {{ 'subscription.setAsDefault' | translate }}
        </button>
      </div>
    </div>
  </div>
   
</div>

